import mergeToNew from "@insite/client-framework/Common/mergeToNew";
import StyledWrapper from "@insite/client-framework/Common/StyledWrapper";
import translate from "@insite/client-framework/Translate";
import { BillToModel } from "@insite/client-framework/Types/ApiModels";
import AddressInfoDisplay, { AddressInfoDisplayStyles } from "@insite/content-library/Components/AddressInfoDisplay";
import { BaseTheme } from "@insite/mobius/globals/baseTheme";
import GridContainer, { GridContainerProps } from "@insite/mobius/GridContainer";
import GridItem, { GridItemProps } from "@insite/mobius/GridItem";
import Icon, { IconPresentationProps } from "@insite/mobius/Icon";
import Link, { LinkPresentationProps } from "@insite/mobius/Link";
import Typography, { TypographyPresentationProps } from "@insite/mobius/Typography";
import { breakpointMediaQueries } from "@insite/mobius/utilities";
import getColor from "@insite/mobius/utilities/getColor";
import InjectableCss from "@insite/mobius/utilities/InjectableCss";
import VisuallyHidden from "@insite/mobius/VisuallyHidden";
import EditIcon from "@tSurya/Icons/EditIcon";
import React from "react";
import { css } from "styled-components";

interface OwnProps {
    billTo: BillToModel;
    onEdit: () => void;
    extendedStyles?: BillingAddressInfoDisplayStyles;
}

export interface BillingAddressInfoDisplayStyles {
    container?: GridContainerProps;
    headingGridItem?: GridItemProps;
    heading?: TypographyPresentationProps;
    editLink?: LinkPresentationProps;
    addressGridItem?: GridItemProps;
    address?: AddressInfoDisplayStyles;
    editText?: InjectableCss;
    iconSyles?: IconPresentationProps;
}

export const billingAddressInfoDisplayStyles: BillingAddressInfoDisplayStyles = {
    container: {
        gap: 0,
        css: css`
            border: 1px solid transparent !important;
        `
    },
    headingGridItem: {
        width: 12,
        css: css`
            padding: 10px;
            border-bottom: 1px solid ${getColor("common.border")};
            position: relative;
        `,
    },
    heading: {
        weight: 700,
        css: css`
            //margin: 0 4rem 0 0;
            font-size: 16px;
            line-height: 24px;
            ${({ theme }: { theme: BaseTheme }) =>
                breakpointMediaQueries(
                    theme,
                    [
                        css`
                            max-width: 100%;
                        `,
                        css`
                            max-width: 100%;
                        `,
                        css`
                            /* max-width: 110px; */
                        `,
                        css`
                            /* max-width: 110px; */
                        `,
                        css`
                            /* max-width: 110px; */
                        `,
                    ],
                    "min",
                )}
        `,
    },
    addressGridItem: {
        width: 12,
        css: css`
            padding: 10px;
        `,
    },
    editLink: {
        css: css`
            display: flex;
            min-width: 55px;
            margin-left: auto;
            > span {
                display: flex;
            }
        `,
    },
    iconSyles: {
        css: css`
            width: 20px;
            margin-right: 5px;
        `,
    },
    editText: {
        css: css``,
    },
};

const BillingAddressInfoDisplay = ({ billTo, onEdit, extendedStyles }: OwnProps) => {
    const styles = mergeToNew(billingAddressInfoDisplayStyles, extendedStyles);
    return (
        <GridContainer {...styles.container}  data-test-selector="billingAddressInfoDisplay_container">
            <GridItem {...styles.headingGridItem}>
                <Typography {...styles.heading}>{translate("Billing Address")}</Typography>
                {/* <Link {...styles.editLink} onClick={onEdit} data-test-selector="checkoutReviewAndSubmit_changeBilling">
                    <Icon src={EditIcon} {...styles.iconSyles}></Icon>
                    <Typography {...styles.editText}>{translate("Edit")}</Typography>
                    <VisuallyHidden>{translate("Billing Address")}</VisuallyHidden>
                </Link> */}
            </GridItem>
            <GridItem {...styles.addressGridItem}>
                <AddressInfoDisplay
                    {...billTo}
                    state={billTo.state ? billTo.state.abbreviation : undefined}
                    country={billTo.country ? billTo.country.abbreviation : undefined}
                    extendedStyles={styles.address}
                />
            </GridItem>
        </GridContainer>
    );
};

export default BillingAddressInfoDisplay;
